import { Button } from "reactstrap"
import AthleteLibraryPanel from "components/Calendar/AthleteLibraryPanel"
import React from "react"
import { FaPen, FaThumbtack } from "react-icons/fa6"
import { MdDelete } from "react-icons/md"
import { Card, CardBody, Input } from "reactstrap"

const SidebarPanel = ({
  activePanel,
  setActivePanel,
  users,
  setUsers,
  selectedUser,
  setSelectedUser,
  getUserData,
  workouts,
  searchTerm,
  setSearchTerm,
  onDragStart,
  setselectedActivity,
  setIsActivityModalOpen,
  handleWorkoutDelete,
  trainingPlans,
  trainingPlanSearch,
  setTrainingPlanSearch,
  setPlanForm,
  setPlanModalMode,
  setIsPlanModalVisible,
  selectedPlan,
  setSelectedPlan,
  setViewingPlanMode,
  handleDeleteTraningPlan,
}) => {
  if (!activePanel) return null

  return (
    <Card className="h-100 slide-panel">
      <CardBody>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">
            {activePanel === "athletes"
              ? "Athlete Library"
              : activePanel === "workouts"
              ? "Workout Library"
              : "Training Plans"}
          </h5>
          <Button close onClick={() => setActivePanel(null)} />
        </div>

        {/* Athlete Panel */}
        {activePanel === "athletes" && (
          <AthleteLibraryPanel
            users={users}
            setUsers={setUsers}
            selectedUser={selectedUser}
            onUserSelect={setSelectedUser}
            getClubs={getUserData}
          />
        )}

        {/* Workouts Panel */}
        {activePanel === "workouts" && (
          <div>
            {/* Search + Add Button */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <Input
                type="text"
                placeholder="Search workouts..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                className="me-2"
              />
              <Button
                color="success"
                onClick={() => {
                  setselectedActivity(null), setIsActivityModalOpen(true)
                }}
              >
                +
              </Button>
            </div>

            {/* Filtered Workout List */}
            {workouts
              .filter(workout =>
                workout.activityTitle
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase())
              )
              .map(workout => (
                <div
                  className="d-flex justify-content-between align-items-center"
                  key={workout.id || workout._id}
                  draggable
                  onDragStart={e => onDragStart(e, workout)}
                  onClick={() => {
                    setselectedActivity(workout)
                    setIsActivityModalOpen(true)
                  }}
                  style={{
                    marginBottom: 10,
                    padding: 8,
                    backgroundColor: "#f0f2f5",
                    borderRadius: 4,
                    cursor: "grab",
                    userSelect: "none",
                  }}
                >
                  <p className="mb-0">{workout.activityTitle}</p>

                  <button
                    className="btn btn-danger p-1"
                    onClick={e => {
                      e.stopPropagation()
                      handleWorkoutDelete(workout._id)
                    }}
                  >
                    <MdDelete size={16} />
                  </button>
                </div>
              ))}
          </div>
        )}

        {/* Training Plans Panel */}
        {activePanel === "training" && (
          <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <Input
                type="text"
                placeholder="Search training plans..."
                value={trainingPlanSearch}
                onChange={e => setTrainingPlanSearch(e.target.value)}
                className="me-2"
              />
              <Button
                color="success"
                onClick={() => {
                  setPlanForm({
                    planName: "",
                    users: [],
                    planType: "free",
                    price: "",
                    bannerImage: null,
                    events: [],
                    type: "",
                    duration: "",
                    linkToFreeUser: false,
                  })
                  setPlanModalMode("add")
                  setIsPlanModalVisible(true)
                }}
              >
                +
              </Button>
            </div>

            {trainingPlans
              .filter(plan =>
                plan.planName
                  .toLowerCase()
                  .includes(trainingPlanSearch.toLowerCase())
              )
              .sort(
                (a, b) =>
                  (b.linkToFreeUser ? 1 : 0) - (a.linkToFreeUser ? 1 : 0)
              )
              .map(plan => (
                <div
                  key={plan._id}
                  style={{
                    marginBottom: 10,
                    padding: plan.linkToFreeUser ? "15px 10px" : 10,
                    borderRadius: 6,
                    position: "relative",
                    backgroundColor: plan.linkToFreeUser
                      ? "#fff3cd"
                      : selectedPlan?._id === plan._id
                      ? "#34c38f"
                      : "#f0f2f5",
                    color: plan.linkToFreeUser
                      ? "#000"
                      : selectedPlan?._id === plan._id
                      ? "#fff"
                      : "#000",
                    border:
                      plan.linkToFreeUser && selectedPlan?._id === plan._id
                        ? "2px solid #0d6efd"
                        : "none",
                  }}
                  className="d-flex justify-content-between align-items-center"
                >
                  <div
                    style={{
                      fontWeight: "bold",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: 2,
                    }}
                    onClick={() => {
                      setSelectedPlan(plan)
                      setViewingPlanMode(true)
                    }}
                  >
                    {plan.planName}
                    {plan.linkToFreeUser && (
                      <FaThumbtack color="#ff8c00" size={16} className="ms-2" />
                    )}
                  </div>

                  <div className="d-flex gap-2">
                    <Button
                      size="sm"
                      color="primary"
                      onClick={() => {
                        setPlanForm({
                          planName: plan.planName,
                          users: plan.users,
                          planType: plan.planType,
                          price: plan.price,
                          description: plan.description,
                          bannerImage: null,
                          events: plan?.events,
                          duration: plan?.duration,
                          type: plan?.type,
                          linkToFreeUser: plan?.linkToFreeUser,
                        })
                        setSelectedPlan(plan)
                        setPlanModalMode("edit")
                        setIsPlanModalVisible(true)
                      }}
                    >
                      <FaPen />
                    </Button>
                    <Button
                      size="sm"
                      color="danger"
                      onClick={() => handleDeleteTraningPlan(plan._id)}
                    >
                      <MdDelete size={16} />
                    </Button>
                  </div>
                </div>
              ))}
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default SidebarPanel
